import { render, staticRenderFns } from "./AccountWithdrawal.vue?vue&type=template&id=568e8abb&"
import script from "./AccountWithdrawal.vue?vue&type=script&lang=js&"
export * from "./AccountWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports